import { fmtPct } from "../../services/retroFormatters";

export default function PlaybookCard({ items = [] }) {
  const done = items.filter((i) => i.done).length;
  const pct = items.length ? Math.round((done / items.length) * 100) : 0;

  return (
    <div className="rtv2-card">
      <div className="rtv2-card-head">
        <div>
          <h3>Move to next level <em>— grow into System Builder</em></h3>
        </div>
        <div className="rtv2-playbook-m">
          <span>{done}/{items.length}</span>
          <div className="trk"><i style={{ width: fmtPct(pct) }} /></div>
          <b>{fmtPct(pct)}</b>
        </div>
      </div>
      <div className="rtv2-playbook-list">
        {items.map((p) => (
          <div className={`rtv2-playbook-item${p.done ? " done" : ""}`} key={p.id}>
            <span className="seq">{p.seq}</span>
            <div className="bd">
              <h4>{p.title}</h4>
              <small>{p.tag}</small>
            </div>
            <span className="st">{p.done ? `Completed · ${p.eta}` : `ETA · ${p.eta}`}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
